import { Language } from "../languages/labels/language.labels";

export function operationTypeList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'in', display: lang.labels.in },
    { code: 'out', display: lang.labels.out },
    { code: 'transfer', display: lang.labels.transfer },
    { code: 'adjustment', display: lang.labels.adjustment }
  ]
}

export function operationTypeValue(lang: Language, code: string): string {
  let operationType = operationTypeList(lang).find((item) => (item.code === code))
  return operationType ? operationType.display : lang.labels.undefined
}
